import React, { createContext, useContext, useEffect, useState, useCallback } from 'react';
import { api } from './api';
import { useAuth } from './auth';

const CartCtx = createContext(null);

export function CartProvider({ children }) {
    const { type } = useAuth();
    const [cart, setCart] = useState({ items: [], item_count: 0, subtotal: 0, total: 0, delivery: 0, tax: 0, savings: 0 });
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const refresh = useCallback(async () => {
        if (type !== 'customer') { setCart({ items: [], item_count: 0, subtotal: 0, total: 0, delivery: 0, tax: 0, savings: 0 }); return; }
        try {
            const { data } = await api.get('/cart');
            setCart(data);
        } catch (e) { /* ignore */ }
    }, [type]);

    useEffect(() => { refresh(); }, [refresh]);

    const add = async (productId, qty = 1) => {
        if (type !== 'customer') throw new Error('login_required');
        setLoading(true);
        try {
            const { data } = await api.post('/cart/add', { product_id: productId, quantity: qty });
            setCart(data); setOpen(true);
            return data;
        } finally { setLoading(false); }
    };

    const update = async (productId, qty) => {
        setLoading(true);
        try {
            const { data } = await api.post('/cart/update', { product_id: productId, quantity: qty });
            setCart(data);
        } finally { setLoading(false); }
    };

    const clear = async () => {
        await api.post('/cart/clear');
        setCart({ items: [], item_count: 0, subtotal: 0, total: 0, delivery: 0, tax: 0, savings: 0 });
    };

    return (
        <CartCtx.Provider value={{ cart, open, setOpen, refresh, add, update, clear, loading }}>
            {children}
        </CartCtx.Provider>
    );
}

export const useCart = () => useContext(CartCtx);
